<script setup lang="ts">
import { inputGroupLabelProps } from 'naive-ui';

const props = defineProps(inputGroupLabelProps);
</script>

<template>
  <!-- The static caption inside a GaiaInputGroup — a unit, a prefix like
       "https://". Reads as part of the field rather than as a separate label. -->
  <n-input-group-label v-bind="props">
    <slot />
  </n-input-group-label>
</template>
